import { useEffect, useState } from 'react';
import { useWorkContext } from '../context/WorkContext';
import Make from './../components/MakeSection/Make';
import Focus from '../components/FocusServices/Focus';
import FAQs from '../components/FAQsSection/FAQs';
import IssueSection from '../components/IssuesSection/Issue';
import RelatedServices from '../components/RelatedServicesSection/RelatedServices';
import LatestArticles from '../components/LatestArticles/LatestArticles';
import ProjectItem from '../components/WorkProjectsList/ProjectItem/ProjectItem';
import HeroSection from '../components/HeroSection/HeroSection';
import SEO from '../components/SEO/SEO';
import { usePageSEO } from '../hooks/usePageSEO';

const Ecommerce = () => {
    const seo = usePageSEO('ecommerce');
    const { getRandomProject } = useWorkContext();
    const [randomProject, setRandomProject] = useState(null);

    useEffect(() => {
        const project = getRandomProject();
        setRandomProject(project);
    }, [getRandomProject]);

    const selectedServiceIds = [3, 4, 7, 9];

    return (
        <>
            <SEO
                title={seo.title}
                description={seo.description}
                keywords={seo.keywords}
                type={seo.type}
                noIndex={seo.noIndex}
                noFollow={seo.noFollow}
            />
            <HeroSection page="eCommercePage" showRecentWork={false} showMoreButton={true} />
            <IssueSection page="eCommercePage" skeletonItemsCount={3} subCountSkeleton={1} />
            <Focus page="eCommercePage" />
            <FAQs page='eCommercePage' />
            <RelatedServices services={selectedServiceIds} />
            <LatestArticles />
            <ProjectItem project={randomProject} index={0} />
            <Make pageKey="ecommercePage" />
        </>
    );
};

export default Ecommerce;